import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../../layout/DisplayDrawerContext";
import { useTradeReviewReportFilter } from "../../../../data/reports/exchbusiness/tradeReview/hooks/useTradeReviewReportFilter";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { CustomTooltip } from "../../../components/common/CustomTooltip";
import { TradeReviewFilterEditor } from "./TradereviewFilterEditor";

export const TradeReviewReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<TradeReviewsFiltEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useTradeReviewReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const TradeReviewsFiltEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useTradeReviewReportFilter();
  return (
    <TradeReviewFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
